<template>
	<div>
		
		<img src="../../assets/img/stockchart.png" /><br/>
	</div>
</template>

<script>
	export default {
		props: ['portfolio'],
		data() {
			return {
			};
		},
		computed: {
			portfolioSetUp() {
				return (typeof this.portfolio.id !== 'undefined');
			}
		},
		methods: {
		}
	};
</script>

<style scoped>	
</style>